import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { useRouter } from 'vue-router';

const router = useRouter();
export const event_obj = mitt();
export const btn_list = [
  {
    name: '详情',
    clazz: 'default',
    cb: (data: any) => {
      router.push({
        path: '/business_manage/profile/basic-franchisee/' + data.id + '/' + data.name,
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
